import { bool, string } from "prop-types"
import { formatDate } from "utils/dates"

const EventStatusIndicator = ({
  open,
  closeAt,
  openAt,
  scheduledToOpen,
  scheduledToClose,
  registerable
}) => {
  let status, openCloseDate

  if (open) {
    status = "Open"

    if (scheduledToClose) {
      openCloseDate = `(until ${formatDate(closeAt)})`
    }
  } else {
    status = "Closed"

    if (scheduledToOpen) {
      openCloseDate = `(until ${formatDate(openAt)})`
    }
  }

  return (
    <div>
      {registerable ? (
        <span>
          {status} {openCloseDate && openCloseDate}
        </span>
      ) : (
        <span>None</span>
      )}
    </div>
  )
}

EventStatusIndicator.propTypes = {
  open: bool,
  closeAt: string,
  openAt: string,
  scheduledToOpen: bool,
  scheduledToClose: bool,
  registerable: bool
}

export default EventStatusIndicator
